import { setMenuPosition } from "./setMenuPosition";
class MainMenu {
    constructor(menu) {
        this.mainMenu = menu;
        this.subMenus = this.getSubMenus();
        this.menuLinks = this.getMenuLinks();
        this.clickAwayHandler = this.clickAwayHandler.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.addEventListeners();
    }
    addEventListeners() {
        document.addEventListener("click", this.clickAwayHandler);
        this.menuLinks.forEach((l) => l.addEventListener("click", this.handleClick));
    }
    getSubMenus() {
        return [...this.mainMenu.querySelectorAll(".sub-menu")];
    }
    getMenuLinks() {
        return [
            ...this.mainMenu.querySelectorAll("#main-menu a"),
        ];
    }
    closeSubMenus(subMenus) {
        subMenus.forEach((s) => {
            [...s.querySelectorAll("a")].forEach((a) => a.classList.remove("active"));
            s.classList.remove("d-block");
        });
    }
    clickAwayHandler(event) {
        const target = event.target;
        if (this.mainMenu.contains(target))
            return;
        if (!this.mainMenu.contains(target)) {
            this.closeSubMenus(this.subMenus);
        }
    }
    handleClick(event) {
        let target = event.target;
        let href = undefined;
        if (!target.nextElementSibling)
            this.closeSubMenus(this.subMenus);
        let dangling = this.subMenus.filter((s) => target.nextElementSibling !== s);
        this.closeSubMenus(dangling);
        if (target.nextElementSibling) {
            event.preventDefault();
            target.nextElementSibling.classList.toggle("d-block");
            setMenuPosition(target.nextElementSibling);
        }
        if (target.nodeName === "IMG") {
            // prevent the event from reaching Barba
            event.stopPropagation();
            target = target.closest("a");
            href = target.href;
            window.location.href = href;
        }
    }
}
export function initMainMenu() {
    const mainMenuElement = document.querySelector("#main-menu");
    return new MainMenu(mainMenuElement);
}
